import { useQuery } from '@tanstack/react-query'
import { apiFetch, getCallerAgentId, hasLiveApi } from '@/api/client'
import { isUnreachableApiError } from '@/api/unreachable'
import type { AgentNode } from '@/api/map/agent'
import { buildMemberDetail, overlayNode } from '@/api/map/member'
import * as api from '@/data/api'
import { keys } from '@/api/hooks/shared/keys'
import type { DateRange } from '@/data/types'

async function loadMemberDetail(id: string, range: DateRange) {
  if (!hasLiveApi()) return api.getMemberDetail(id, range)
  try {
    const rootId = getCallerAgentId()!
    const [tree, node] = await Promise.all([
      apiFetch<AgentNode[]>(`/v1/agents/${rootId}/tree`),
      apiFetch<AgentNode>(`/v1/agents/${id}`),
    ])
    return buildMemberDetail(overlayNode(tree, node), id, rootId)
  } catch (err) {
    if (isUnreachableApiError(err)) return null
    throw err
  }
}

export function useMemberDetail(id: string | undefined, range: DateRange) {
  return useQuery({
    queryKey: keys.memberDetail(id ?? '', range),
    queryFn: () => loadMemberDetail(id!, range),
    enabled: Boolean(id),
  })
}
